// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 354 ? "31a19646" : chunkId) + "." + {"354":"50c7c2945a4b5147","896":"1e987dcfff06abd4"}[chunkId] + ".js";
};